import { AUTH_PORTAL } from '@/auth';
import type {
  LoginForm,
  LoginResponse,
  LoginApiResponse,
  ResendOtpResponse,
  ResetPasswordForm,
  ForgotPasswordResponse,
} from '@gokrew/models/auth';
import type { ApiResponse } from '@gokrew/models/generic';
import api from './client';

export async function login(payload: LoginForm): Promise<LoginApiResponse> {
  const { data } = await api.post<LoginApiResponse>('/auth/login', payload, {
    headers: { portal: AUTH_PORTAL, 'x-platform-type': 'web' },
  });
  return data;
}

export async function verifyOtp(
  otpToken: string,
  otp: string
): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>(
    '/auth/verify-otp',
    { otpToken, otp },
    { headers: { portal: AUTH_PORTAL, 'x-platform-type': 'web' } }
  );
  return data;
}

export async function resendOtp(otpToken: string): Promise<ResendOtpResponse> {
  const { data } = await api.post<ResendOtpResponse>(
    '/auth/resend-otp',
    { otpToken },
    { headers: { portal: AUTH_PORTAL, 'x-platform-type': 'web' } }
  );
  return data;
}

export async function changePassword(
  payload: ResetPasswordForm
): Promise<ApiResponse> {
  const { data } = await api.post<ApiResponse>(
    '/auth/change-password',
    payload
  );
  return data;
}

export async function sendForgotPasswordLink(
  email: string
): Promise<ForgotPasswordResponse> {
  const { data } = await api.post<ForgotPasswordResponse>(
    '/forgot-password',
    { email },
    { headers: { portal: AUTH_PORTAL } }
  );
  return data;
}

export async function resetForgotPassword(
  token: string,
  newPassword: string
): Promise<ForgotPasswordResponse> {
  const { data } = await api.post<ForgotPasswordResponse>(
    '/reset-password',
    { token, newPassword },
    { headers: { portal: AUTH_PORTAL } }
  );
  return data;
}

export async function logoutUser(): Promise<{ message: string }> {
  const { data } = await api.post<{ message: string }>(
    '/auth/logout',
    {},
    { headers: { portal: AUTH_PORTAL, 'x-platform-type': 'web' } }
  );
  return data;
}
